import React, { useEffect } from "react";
import { Bounce, toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CustomToast({ body, status, setStatus }) {
  useEffect(() => {
    if (!status) return;

    const options = {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
      onClose: () => setStatus('')
    };

    if (status === "success" || status === "SUCCESS") {
      toast.success(body, options);
    } else if (status === "error" || status === "ERROR") {
      toast.error(body, options);
    }

    return () => {
      toast.dismiss();
    };
  }, [status, body, setStatus]);

  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      transition={Bounce}
      limit={1}
    />
  );
}

export default CustomToast;